import { render, staticRenderFns } from "./FleetsView.vue?vue&type=template&id=67b73717&scoped=true&"
import script from "./FleetsView.vue?vue&type=script&lang=js&"
export * from "./FleetsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b73717",
  null
  
)

export default component.exports